// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchTabs-module__icon___8dZeJ"};